/** Standard empty states */
export const MSG_NO_EVENTS = "No events found"
